import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const protocolValues = ['TCP', 'UDP']

const options = protocolValues?.map((protocol) => ({
  label: protocol,
  value: protocol,
}))

interface Props {}

export default function ProtocolPicklist({
  name = 'protocol',
  label = 'Protocol',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
